import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {MONTH_NAMES} from "../shared/dateTimeLists";

const ReportDate = () => {
    const d = new Date();
    let mo = MONTH_NAMES[(d.getMonth())];
    let hr = d.getHours();
    let ampm = 'am';
    if (hr > 12) {
        hr -= 12;
        ampm = 'pm';
    }
    let min = String('00' + d.getMinutes()).slice(-2);
    const str = mo + ' ' + d.getDate() + ', ' + d.getFullYear() + ', ' + hr + ':' + min + ' ' + ampm;
    return (
        <span>{str}</span>
    );
};

/**
 * Print Header Layout for Reports.
 *
 */
class ReportHeaderLocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            location: {},
            reportType: 'Report',
            zeroDay: null
        };
    }

    componentWillMount() {
        this.setState({
            location: this.props.location,
            reportType: this.props.reportType,
            zeroDay: this.props.zeroDay
        });
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.location !== this.props.location ||
            nextProps.reportType !== this.props.reportType ||
            nextProps.zeroDay !== this.props.zeroDay
        ) {
            this.setState({
                location: nextProps.location,
                reportType: nextProps.reportType,
                zeroDay: nextProps.zeroDay
            });
        }
    }

    render() {

        const {
            location,
            reportType,
            zeroDay
        } = this.state;

        const styles = {
            container: {
                display: 'none',
                width: '100%',
                margin: '0 0 2em 0',
            },
            logoContainer: {
                display: 'inline-block',
                width: '25%',
                verticalAlign: 'top',
            },
            logoImage: {
                width: '100%',
                height: 'auto',
            },
            locationContainer: {
                display: 'inline-block',
                width: '75%',
                color: '#333333',
                verticalAlign: 'top',
            },
            h1: {
                fontSize: '2em',
                fontWeight: 500,
                margin: '0 0 1em 0',
            },
            h2: {
                fontSize: '1.5em',
                fontWeight: 500,
                margin: '0 0 0.5em 0',
            },
            p: {
                fontSize: '1em',
                margin: '0 0 0.5em 0',
            },
            table: {
                width: '100%',
                margin: '1em 0 1em 0',
            },
            td: {
                fontSize: '0.975em',
                color: '#666666',
                textAlign: 'left',
                padding: '3px 6px 4px 2px',
            },
            half: {width: '50%'},
        };
        return (
            <div>
                {location && location.id &&
                <div className="report-header" style={styles.container}>

                    {/* Header Column: Location */}
                    <div style={styles.locationContainer}>
                        <div style={styles.h1}>{location.name} - {reportType}</div>
                        <div style={styles.h2}>Location #{location.id} - {location.city}, {location.state}</div>
                        <div style={styles.p}>Report Date: <span className="bold">{<ReportDate/>}</span></div>
                        {zeroDay &&
                        <div style={styles.p}>Zero Day: <span className="bold">{zeroDay}</span></div>
                        }

                        {/* Location Details Table */}
                        <table className="header-table location" style={styles.table}>
                            <thead>
                            <tr>
                                <th style={styles.td}>Location</th>
                                <th style={styles.td}>Location Details</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="half" style={styles.half}>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style={styles.td}>ID</td>
                                            <td style={styles.td}>{location.id}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Name</td>
                                            <td style={styles.td}>{location.name}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Address</td>
                                            <td style={styles.td}>{location.address}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>City</td>
                                            <td style={styles.td}>{location.city}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>State</td>
                                            <td style={styles.td}>{location.state}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Zip</td>
                                            <td style={styles.td}>{location.zipcode}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Phone</td>
                                            <td style={styles.td}>{location.telephone}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>City Limits</td>
                                            <td style={styles.td}>{location.city_limits}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Lat / Lon</td>
                                            <td style={styles.td}>{location.latitude}, {location.longitude}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td className="half" style={styles.half}>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style={styles.td}>Is Open</td>
                                            <td style={styles.td}>{location.is_open}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Close Transfer Warehouse</td>
                                            <td style={styles.td}>{location.close_transfer_warehouse}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>District ID</td>
                                            <td style={styles.td}>{location.district_id}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Location Type ID</td>
                                            <td style={styles.td}>{location.location_type_id}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Season Type</td>
                                            <td style={styles.td}>{location.season_type}</td>
                                        </tr>
                                        <tr>
                                            <td style={styles.td}>Price Level</td>
                                            <td style={styles.td}>{location.priceLevel}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            </tbody>

                        </table>
                    </div>

                    {/* Header Column: Logo */}
                    <div style={styles.logoContainer}>
                        <img src="CloudSent-POS-logo-admin.png" style={styles.logoImage} alt="CloudSent POS"/>
                    </div>
                </div>
                }
            </div>
        )
    }
}

ReportHeaderLocation.propTypes = {
    location: PropTypes.object.isRequired,
    reportType: PropTypes.string,
    zeroDay: PropTypes.string
};

ReportHeaderLocation.defaultProps = {
    location: {},
    reportType: 'Report',
    zeroDay: null
};

export default ReportHeaderLocation;



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportHeaderLocation.js